function currency(state = {}, action) {
  switch (action.type) {
    case "SET_CURRENCIES":
      const { currencies } = action
      return { currencies };
    case "SET_TRANS_CURRENCY":
      const { currencyId } = action
      return {
        ...state,
        transCurrency: state.currencies.find(currency => currency.id === currencyId)
      };
    default:
      return state;
  }
}
export default currency;
